import { ILoading } from "../models";
import {
    CHANGE_SORT_ORDER,
	Actions
} from "../actions";

export function sortingReducer(state = { sortOrder: "ASC" }, action: Actions) {
	switch (action.type) {
		case CHANGE_SORT_ORDER:
			return action.payload ? action.payload : {};
		default: return state;
	}
}


// WEBPACK FOOTER //
// ./src/client/reducers/sorting.ts